import * as Yup from "yup";

import {ColumnOption} from "@/components/columnSelector/ColumnSelector.types.ts";
import {SelectOption} from "@/components/select/Select.types.ts";
import {ChecksListView} from "@/lib/types/checksListViews.ts";
import {DEFAULT_COLUMNS} from "@/pages/checks/list/columns/checksColumnSpecs.tsx";
import {ViewEditorFormFields} from "@/pages/checks/list/components/ViewEditor/ViewEditor.types.ts";

// Names reserved for built-in views. Compared case-insensitively against the trimmed name.
const RESERVED_VIEW_NAMES = ["standard"];

export const viewEditorSchema = Yup.object({
  name: Yup.string()
    .trim()
    .required("View name is required.")
    .max(100, "View name must be at most 100 characters.")
    .test(
      "not-reserved",
      "This name is reserved. Please choose a different name.",
      (value) => !RESERVED_VIEW_NAMES.includes((value ?? "").trim().toLowerCase())
    ),
  columns: Yup.array().of(Yup.mixed<ColumnOption>().required()).required().min(1, "Select at least one column."),
  default_sort: Yup.string().required(),
  default_sort_direction: Yup.string().required(),
  is_default: Yup.boolean().required(),
});

export const sortDirectionOptions: SelectOption[] = [
  {label: "Ascending", value: "asc"},
  {label: "Descending", value: "desc"},
];

export const buildDefaultValues = (
  editingView: ChecksListView | null,
  availableColumns: ColumnOption[]
): ViewEditorFormFields => {
  const columnIds = editingView ? editingView.columns : DEFAULT_COLUMNS;
  const columns = columnIds
    .map((id) => availableColumns.find((col) => col.id === id))
    .filter((col): col is ColumnOption => col !== undefined);

  return editingView
    ? {
        name: editingView.name,
        columns,
        default_sort: editingView.default_sort,
        default_sort_direction: editingView.default_sort_direction,
        is_default: editingView.is_default,
      }
    : {
        name: "",
        columns,
        default_sort: "name_lower",
        default_sort_direction: "asc",
        is_default: false,
      };
};
